/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePatientDto } from '../../models/create-patient-dto';
import { ResponsePatientDto } from '../../models/response-patient-dto';

export interface PatientsControllerCreate$Params {
      body: CreatePatientDto
}

export function patientsControllerCreate(http: HttpClient, rootUrl: string, params: PatientsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePatientDto>> {
  const rb = new RequestBuilder(rootUrl, patientsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePatientDto>;
    })
  );
}

patientsControllerCreate.PATH = '/thalea-patients/patients';
